import { setCommonData } from "../../../contractManagement/AppStore/ActionCreator/commonDataAction";

export const getCommonDataForTariff = (value: any) => {
    return async (dispatch : any ,getState : any) => {
        const commonData = await dispatch(setCommonData(value))
        return commonData
    }
}